import { Align, Text, VerticalSpace } from '@arc-ui/components';

const NoResults: React.FC = () => (
  <Align horizontal="center">
    <Text size="l">
      <b>No results found</b>
    </Text>
    <VerticalSpace size="20" />
    <Text size="m">
      We couldn&apos;t find any results matching your filters or search. Try
      adjusting your filters or using a different search term.
    </Text>
  </Align>
);

export default NoResults;
